import Loader from "./Loader";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Theme } from "../../data/style/Theme";
import { useQuery } from "@tanstack/react-query";
import { getAthleteProfile } from "../../api/user";
import { useAuth } from "../../context/AuthContext";
import {
  MainText,
  SmallTitle,
  SpacedRow,
  CenteredRow,
} from "../../data/style/Style";

const TopAthlete = ({ athlete, title, type }) => {
  const { settings } = useAuth();

  const { data, isPending } = useQuery({
    queryKey: ["athlete", athlete.id],
    queryFn: ({ signal }) => getAthleteProfile({ userId: athlete.id, signal }),
    staleTime: 30 * 60 * 1000,
  });

  return (
    <SpacedRow
      alignItems={"center"}
      gap={1}
      p={1}
      sx={{
        border: 1,
        borderRadius: 4,
        borderColor: Theme.palette.border,
        background: Theme.palette.card,
      }}
    >
      {!isPending ? (
        <>
          <CenteredRow gap={2}>
            <Box
              sx={{
                width: "60px",
                height: "60px",
                borderRadius: "50%",
              }}
              component="img"
              alt="Athlete Photo"
              src={data.image}
            ></Box>
            <Stack gap={1}>
              <SmallTitle fontSize={"0.6rem"}>{title}</SmallTitle>
              <MainText>{data.name}</MainText>
            </Stack>
          </CenteredRow>
          <MainText
            fontWeight={700}
            sx={{
              color:
                type === "cardio"
                  ? Theme.palette.up + " !important"
                  : type === "gymnastics"
                    ? Theme.palette.blue + " !important"
                    : Theme.palette.gold + " !important",
            }}
          >
            {type === "weightlifting"
              ? settings.weight === 1
                ? athlete.score_lb
                : athlete.score
              : athlete.score}
          </MainText>
        </>
      ) : (
        <Loader />
      )}
    </SpacedRow>
  );
};

export default TopAthlete;
